import type { BackendRouteDefinition } from '../types';
import { disablePaymentInstrumentRoute } from './disablePaymentInstrument';
import { getPaymentInstrumentsForFirmClientRoute } from './getPaymentInstrumentsForFirmClient';
import { getPaymentPageUnauthenticatedRoute } from './getPaymentPageUnauthenticated';
import { setDefaultPaymentInstrumentIdForMatterRoute } from './setDefaultPaymentInstrumentIdForMatter';
import { submitPaymentFromClientToFirmRoute } from './submitPaymentFromClientToFirm';

// Phase 3 migration work blocks each own one route-definition module so future
// transport flips stay isolated to a single file and avoid cross-block merge conflicts.
export const paymentRoutes = {
  disablePaymentInstrument: disablePaymentInstrumentRoute,
  getPaymentPageUnauthenticated: getPaymentPageUnauthenticatedRoute,
  submitPaymentFromClientToFirm: submitPaymentFromClientToFirmRoute,
  getPaymentInstrumentsForFirmClient: getPaymentInstrumentsForFirmClientRoute,
  setDefaultPaymentInstrumentIdForMatter:
    setDefaultPaymentInstrumentIdForMatterRoute,
} as const satisfies Record<string, BackendRouteDefinition>;
